module.exports = __webpack_public_path__ + "static/media/single-product.532a859a.jpg";